import {IAddBox} from "src/store/actions";
import {EFruits} from "src/store/enums";
import {IAppState} from "src/store/models";

export const addBoxReducer = (state: IAppState, action: IAddBox) => {
    const {shelfId, boxId, defaultSize = 1, defaultKind = EFruits.LEMON} = action.payload;
    const oldBoxes = state.shelves[shelfId].boxesIds;
    return {
        ...state,
        boxes: {
            ...state.boxes,
            [boxId]: {
                defaultKind,
                defaultSize,
                fruitsIds: [],
                shelfId
            }
        },
        shelves: {
            ...state.shelves,
            [shelfId]: {
                boxesIds: [...oldBoxes, boxId]
            }
        }
    };
};


// WEBPACK FOOTER //
// ./src/store/reducers/adding/addBoxReducer.ts